// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"format-vertical-align-center"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 5H21M6 12H18M3 19H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FormatVerticalAlignCenterIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'format-vertical-align-center',
    ref,
    icon: element,
  },
));

FormatVerticalAlignCenterIcon.displayName = 'FormatVerticalAlignCenterIcon';

export default FormatVerticalAlignCenterIcon;
